import React, { createContext, useReducer } from "react";

const initialState = {
    notification: null
};

const reducer = (state, action) => {
    const currentState = { ...state};
    switch(action.type) {
        case "notification":
            currentState.notification = action.payload;
            return currentState;
        default:
            throw new Error();
    }
};

const StateProvider = ({ children }) => {
    let state, dispatch;
    [state, dispatch] = useReducer(reducer, initialState);

    return <StateContext.Provider value={[ state, dispatch ]}>{ children }</StateContext.Provider>;
}

export const StateContext = createContext(initialState);
export default StateProvider;